<template>
  <div class="mt-4 mb-4 pa-5" style="width:100%;">
    <h2>About</h2>
    <p>本サイトは人気Youtuberの最新の動画、チャンネル情報を集約したものです。</p>
    <p />
    <p>Youtube Data Api から人気動画情報を取得し、当サイトの管理DBに格納したものを条件別に抽出して表示しています。</p>
    <p />
    <p>クライアントサイドはVue.jsのUIライブラリのVuetifyで構築しています。</p>
    <p />
    <p>言語は Laravel Framework 6.5.0 + Vue.js 3.5.0 を使用しています。</p>
    <p />
    <p>本サイトはVue.jsのスキル習得を目的として簡易的に作成しています。</p>
    <br />
    <h2>Profile</h2>
    <p>当方、大阪市内在住でWeb系のフリーランスエンジニアとして活動しています。</p>
    <p />
    <p>主な開発経験、習得スキルは以下の通りです。</p>
    <br />
    <v-simple-table class="skill">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">スキル概要</th>
            <th class="text-left">詳細</th>
            <th class="text-left">経験年数</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>PHP</td>
            <td>
              メインの習得スキルです。
              <br />レガシー、frameworkでの開発経験どちらもあります。
              <br />コンシューマ向けWebサービス、企業向け業務アプリケーションに開発を行いました。
            </td>
            <td>3年</td>
          </tr>
          <tr>
            <td>Java</td>
            <td>業務系アプリケーションの保守運用にてJSPを使用した画面UIとサーバーロジックの改修を行いました。</td>
            <td>1年</td>
          </tr>
          <tr>
            <td>C#</td>
            <td>.NET Framework 4.5を使用した業務系アプリケーションのWebAPIを開発しました。</td>
            <td>6か月</td>
          </tr>
          <tr>
            <td>AngularJS</td>
            <td>業務用webアプリケーションの新規開発案件で画面の作成を行いました。</td>
            <td>6か月</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <br />
    <h2>Contact</h2>
    <p>下記連絡先より、お仕事のご依頼、お見積り等承ります。</p>
    <p>メールアドレス: sk88freebiz@gmail.com</p>
  </div>
</template>

<script>
export default {
  name: "Contact",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.skill td {
  height: 100px;
}
</style>
